export const WITH_SERVICES_STATUSES_COLORS = {
    1: 'primary',
    2: 'yellow',
    3: 'yellow',
    4: 'red',
    5: 'yellow',
    6: 'yellow',
    7: 'yellow',
    8: 'yellow',
    9: 'yellow',
    10: 'green',
    11: 'red',
    12: 'yellow',
    13: 'yellow',
    14: 'yellow',
    20: 'red',
    51: 'red',
    54: 'yellow',
}

export const WITH_SERVICES_STATUSES = [
    { id: 1, name: 'Заказ создан' },
    { id: 2, name: 'Забирается курьером' },
    { id: 3, name: 'Груз забран у отправителя' },
    { id: 5, name: 'Обработка груза на складе' },
    { id: 6, name: 'Груз обработан и ожидает отправку' },
    { id: 7, name: 'Груз в пути' },
    { id: 8, name: 'Груз в городе назначения' },
    { id: 9, name: 'Доставляется курьером' },
    { id: 10, name: 'Доставлен' },
    { id: 11, name: 'Доставка отменена получателем' },
    { id: 12, name: 'Доставляется в ПВЗ' },
    { id: 13, name: 'Доставлен в ПВЗ' },
    { id: 14, name: 'Забран получателем из ПВЗ' },
]

export const WITH_SERVICES_STATUSES_ADDITIONAL = [
    { id: 17, name: 'Создан' },
    { id: 18, name: 'Завершен' },
]

export const NOT_STATUS_IDS = [4, 11, 51]
